import React from "react";
import { Modal, Box, Typography, IconButton, Slide, Link } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Link as RouterLink } from "react-router-dom";

const Transition = React.forwardRef(function Transition(props: any, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SwipingModal = ({
  title,
  titleLink,
  isOpen: open,
  onClose,
  content,
}: any) => {
  const TitleContent = () => {
    if (titleLink) {
      return (
        <Link
          component={RouterLink}
          to={titleLink}
          sx={{
            color: "#1976d2",
            textDecoration: "none",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {title}
        </Link>
      );
    }
    return title;
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      sx={{
        display: "flex",
        alignItems: "end",
        justifyContent: "center",
      }}
    >
      <Transition in={open}>
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: "25px 25px 0 0",
            width: "100%",
            maxHeight: "80%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 12,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box sx={{ p: 3, overflowY: "auto" }}>
            <Typography id="select-network-title" variant="h6" component="h2">
              <TitleContent />
            </Typography>
          </Box>

          <Box sx={{ p: 2, overflowY: "auto" }}>{content}</Box>
        </Box>
      </Transition>
    </Modal>
  );
};

export default SwipingModal;
